import { breakpoints } from '@notino/react-styleguide';

import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import theme from '@themes/default';

export const VoucherDiscountInfoWrapper = styled.div<{
  isUnderSelectBox?: boolean;
}>`
  position: relative;
  padding: 0.75rem;
  border-radius: 2px;

  background-color: ${theme.color.common.magenta95};

  margin: ${(props) =>
    props.isUnderSelectBox ? '0 0 0.75rem 0' : '0.75rem 0 0.75rem 0'};

  @media (min-width: ${breakpoints.md}) {
    margin: 1rem 0 0.75rem 0;
  }
`;

export const arrowClass = css`
  &::after {
    content: ' ';
    height: 1rem;
    width: 1rem;
    background-color: ${theme.color.common.magenta95};
    border-radius: 2px;
    position: absolute;
    top: -5px;
    right: 1.3rem;
    transform: rotate(45deg);
  }
`;

export const VoucherDiscountInfoFlex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DiscountInfoDescription = styled.div`
  text-align: left;
  flex: 1;
`;

export const DiscountAmountWrapper = styled.span<{
  isStressed: boolean;
  color?: string;
}>`
  color: ${({ color = theme.color.text.highlight }) => color};
  margin-right: 5px;

  ${theme.typography.labelRegular}

  line-height: ${({ isStressed }) => (isStressed ? '1.5rem' : '1.3rem')};
  font-size: ${({ isStressed }) => (isStressed ? '1.25rem' : '1.12rem')};
  font-weight: ${({ isStressed }) => (isStressed ? 500 : 400)};
`;

export const CodeWrapper = styled.span`
  text-transform: uppercase;
  color: ${theme.color.text.primary};

  ${theme.typography.labelRegular}
`;

export const TermsWrapper = styled.div`
  font-size: 0.75rem;
  color: ${theme.color.text.tertiary};
  font-weight: normal;
  display: inline;

  @media (min-width: ${breakpoints.sm}) {
    align-items: center;
  }
  @media (min-width: ${breakpoints.md}) {
    align-items: center;
    display: block;
  }
`;

export const TextWrapper = styled.div<{
  isStressed: boolean;
  columnOnMobile: boolean;
}>`
  margin-bottom: 0.125rem;
  color: ${theme.color.text.secondary};
  display: flex;
  flex-wrap: wrap;

  ${theme.typography.labelRegular400}

  flex-direction: ${({ columnOnMobile }) =>
    columnOnMobile ? 'column' : 'row'};

  align-items: ${({ columnOnMobile }) =>
    columnOnMobile ? 'flex-start' : 'flex-end'};

  @media (min-width: ${breakpoints.md}) {
    flex-direction: row;
    align-items: flex-end;
  }
`;

export const VoucherDiscountIconWrapper = styled.div`
  margin: 0 0 0 2rem;

  @media (min-width: ${breakpoints.sm}) {
    margin: 0 0 0 1rem;
  }

  @media (min-width: ${breakpoints.md}) {
    margin: 0 0 0 2.5rem;
  }

  z-index: 1;
  > div {
    font-size: 0.9rem;
    font-weight: 500;
    width: 3rem;
    height: 3rem;
    > span {
      margin: 0;
    }
  }
`;

export const InfoIconWrapper = styled.span`
  display: flex;
  align-items: center;
  margin-top: 0.1rem;
  margin-left: 4px;
  position: relative;
  top: 2px;
  scale: 1.2;

  @media (min-width: ${breakpoints.sm}) {
    margin-top: 0;
  }
`;

export const InstructionTextWrapper = styled.span`
  padding-right: 0.3rem;

  ${theme.typography.labelSmall400}
  color: ${theme.color.text.secondary};
`;
